import { render, staticRenderFns } from "./WMultipleBarBasic.vue?vue&type=template&id=2e44f6cc&"
import script from "./WMultipleBarBasic.vue?vue&type=script&lang=js&"
export * from "./WMultipleBarBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports